import { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";

import { GridLayout } from "./GridLayout";
import { Layout } from "./Layout";
import "./SimplePromptStudio.css";
import { useCustomToolStore } from "../../store/custom-tool-store";
import useSimplePromptStudio from "../hooks/useSimplePromptStudio";
import { SpinnerLoader } from "../../components/widgets/spinner-loader/SpinnerLoader";
import { LANDING, SPS_ID, UPLOAD } from "./constants";

function SimplePromptStudio() {
  const [isLoading, setIsLoading] = useState(true);
  const { details, listOfDocs } = useCustomToolStore();
  const { handleSpsNavigate } = useSimplePromptStudio();
  const [searchParams] = useSearchParams();

  useEffect(() => {
    // If tool_name is not set, navigate to landing page
    if (!details?.tool_name) {
      handleSpsNavigate(LANDING);
      return;
    }

    // If no documents are present, navigate to upload page
    if (!listOfDocs?.length) {
      handleSpsNavigate(UPLOAD);
      return;
    }

    // If sps_id parameter is missing, navigate to default page
    const projectId = searchParams.get(SPS_ID);
    if (!projectId) {
      handleSpsNavigate("");
    }

    // Set loading state to false once initial checks are done
    setIsLoading(false);
  }, [details, listOfDocs, searchParams, handleSpsNavigate]);

  if (isLoading) {
    return <SpinnerLoader />;
  }

  return (
    <div className="sps-layout">
      <Layout>
        <GridLayout />
      </Layout>
    </div>
  );
}

export { SimplePromptStudio };
